import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import PageShell, { PageTitle } from '../components/PageShell';
import CallButton from '../components/CallButton';
import HelpBox from '../components/HelpBox';
import FaqAccordion from '../components/FaqAccordion';
import { FAQ_GROUPS } from '../constants/content';

export default function FaqPage() {
  return (
    <PageShell>
      <PageTitle
        title="Family Tree Maker Questions & Answers"
        lead="Short, practical answers to the things people ask us most, grouped by topic so you can jump straight to yours."
        crumbs={[{ label: 'FAQs' }]}
      />

      <nav className="toc" aria-label="FAQ sections">
        {FAQ_GROUPS.map((group) => (
          <Link key={group.id} to={`/faqs#${group.id}`}>
            {group.title}
          </Link>
        ))}
      </nav>

      <CallButton />

      {FAQ_GROUPS.map((group, index) => (
        <Fragment key={group.id}>
          <section id={group.id} className="entry-section">
            <h2>{group.title}</h2>
            <FaqAccordion items={group.items} />
          </section>
          {index % 2 === 1 ? <CallButton /> : null}
        </Fragment>
      ))}

      <p className="text-center">
        Still wondering about something? Our <Link to="/blogs">how-to library</Link> goes into more depth, or you can simply ask a technician.
      </p>

      <HelpBox
        title="Your Question Not Here?"
        text="Ask it directly. Our technicians answer by phone and live chat at any hour."
      />
    </PageShell>
  );
}
